import { registerPlugin } from '@capacitor/core';
const AssetDelivery = registerPlugin('AssetDelivery', {
    web: () => import('./web').then((m) => new m.AssetDeliveryWeb()),
});
export * from './definitions';
export { AssetDelivery };
//# sourceMappingURL=index.js.map